import React, { useState } from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

export default function FormControlLabelPlacement(props) {

    // const [value, setValue] = React.useState('Any');

    // const handleChange = (event) => {
    //     console.log(event.target.value)
    //     props.setLanguage(event.target.value);
    // };


    return (
        <FormControl component="fieldset">
            <FormLabel component="legend">Select preferred language for articles</FormLabel>
            <RadioGroup row aria-label="position" name="position" value={props.language} onChange={(event) => props.handleChange(event)} >

                <FormControlLabel value="eu" control={<Radio color="primary" />} label="english" labelPlacement="start" />

                <FormControlLabel value="hi" control={<Radio color="primary" />} label="hindi" labelPlacement="start" />

                <FormControlLabel value="Any" control={<Radio color="primary" />} label="All" labelPlacement="start" />

            </RadioGroup>
        </FormControl>
    );
}